import { HttpClient as NgHttpClient } from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";
import { LoggingFactory } from "@obg/ngx.global.evo";

import { REGISTER_KEY_DEPENDENCY_TOKEN, RegisterKeyDependencyFn } from "../model";
import { PrefetchService } from "../prefetch/prefetch.service";

import { HttpClient, RequestPayload } from "./http-client.model";
import { HttpClientService } from "./http-client.service";

@Injectable({
	providedIn: "root",
})
export class HttpClientFactory {
	constructor(
		private http: NgHttpClient,
		private loggingFactory: LoggingFactory,
		private prefetchService: PrefetchService,
		@Inject(REGISTER_KEY_DEPENDENCY_TOKEN) @Optional() private registerKeyDependency: RegisterKeyDependencyFn
	) {}

	get(defaultConfiguration?: RequestPayload): HttpClient {
		return new HttpClientService(
			this.loggingFactory,
			this.http,
			this.prefetchService,
			this.registerKeyDependency,
			defaultConfiguration
		);
	}
}
